import React from 'react';
import store from '../../store/Store';

import actionTypes from '../../actionTypes/actionTypes';
import actions from '../../actions/Actions';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { Redirect } from 'react-router-dom';

import Navigation from '../navigation/Navigation'

import './editorUser.scss'

type editorUserState = {
	article: any;
  navigation: any;
  history: any;
  user: any;
}

type editorUserProps = {
	article: any;
  navigation: any;
  history: any;
}

class EditorUser extends React.Component<editorUserProps, editorUserState> {

  constructor(props) {
  	super(props)

    console.log(this.props)

  	this.state = {
      history: props.history,
  		article: props.article,
      navigation: props.navigation,
      user: store.getState().user
  	}
  }

  componentDidMount() {
    console.log('EditorUser Did Mount')

  	store.subscribe(() => {
  		this.setState({
  			article: store.getState().article,
        navigation: store.getState().navigation,
        user: store.getState().user
  		})
  	})
  }

  componentWillUnmount() {
    console.log('EditorUser Will Unmount')

    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

	render() {
		const {
			article,
	      navigation,
	      history,
	      user
		} = this.state

		return (
			<div
				className="EditorUser"
		        style={{
		          width: '100vw',
		          height: 'calc(100vh - 50px)',
		          margin: '50px 0 0 0',
		          overflow: 'hidden'
		        }}
			>
        		<div
        			style={{
        				width: '400px',
        				margin: '30px auto 0 auto'
        			}}
        		>
        			Title: { user.title }<br />
        			Name: { user.name }<br />
        			Last Name: { user.lastName }<br />
        			Username: { user.username }<br />
        			E-Mail: { user.email }<br />
        			Password: { user.password }<br />
        			Gender: { user.gender }<br />
        			Role: { user.role }<br />
        			Admin: { user.admin }<br />

        			<br />

        			Activity <br />
        			Last: <br />
        			Total: <br />

        			<br />

        			Articles <br />
        			Writted: <br />
        			Proofed: <br />
        			Published: <br />
        		</div>
			</div>
		);
	}
}

export default EditorUser;